export default __webpack_public_path__ + "static/media/uz.90d8f8dd.svg";